import { IExpression } from "@@expressions";
import { IComponent } from "./IComponent";

export enum CheckboxStyle {
  Checkbox = "Checkbox",
  Switch = "Switch",
  Toggle = "Toggle",
}

export type InputCheckboxModel = IComponent & {
    Label: string;
    Style?: CheckboxStyle;
    Value?: IExpression;
    DefaultValue?: IExpression;
    Description?: string;
    Disabled?: IExpression;
    DisabledTooltip?: string;
};
